//Use this place to tranform material UI or your own components into redux form components

import React from 'react';
import {
  Input as MyInput,
  Dropdown as MyDropdown,
  RadioButtonGroup as RadioGroup,
  CheckBox as MyCheckbox,
  DatePicker as MyDatePicker,
} from '@ds/react-components';

export const Input = (params) => {
  const { label, input, meta, isSubmitting, ...custom } = params;
  const showError = shouldShowError(params);
  return (
    <MyInput
      label={label}
      placeholder={label}
      error={showError} //show error or not
      helperText={showError && meta.error} //error message text
      {...input}
      {...custom}
    />
  );
};

export const RadioButtonGroup = (params) => {
  const { input, ...custom } = params;
  return <RadioGroup {...input} {...custom} />;
};

export const Dropdown = (params) => {
  const { input, meta, ...custom } = params;
  const showError = meta.touched && meta.invalid;
  return (
    <MyDropdown
      {...input}
      {...custom}
      error={showError}
      helperText={showError && meta.error}
    />
  );
};

export const CheckBox = (params) => {
  const { input, ...custom } = params;
  return (
    <MyCheckbox {...input} checked={input.value ? true : false} {...custom} />
  );
};

export const DatePicker = (params) => {
  const { input, meta, ...custom } = params;
  const showError = meta.touched && meta.invalid;

  return (
    <MyDatePicker
      {...custom}
      error={showError}
      helperText={showError && meta.error}
      date={input.value}
      onChange={(date) => {
        input.onChange(date);
      }}
    />
  );
};

/**show error message only when:
 * 1. input is invalid from form validation,
 * 2. and not active (focus is out) or when input reaches its max length: maxlength property for standard input or masked pattern length for a masked input */
const maskedPlaceholderChar = '_'; //by default for react-maskedInput
const shouldShowError = (params) => {
  const { input, meta, maxLength, mask } = params;
  //it needs to be a masked input or you have set the maxlength property of the input
  const reachMaxLength = mask
    ? input.value.replace(maskedPlaceholderChar, '').length === mask.length
    : input.value.length === maxLength;
  return meta.touched && meta.invalid && (!meta.active || reachMaxLength);
};
